import * as httpx from "httpx"
import * as metasearch from "metasearch"
import { SearchRequest, SearchResponse } from "./brandguard.metrics_pb"
import { GroupBy } from "metasearch/meta.search.filters"
import { CancellablePromise } from "real-cancellable-promise"

import * as uuid from "uuid"

export interface AssetTypeMetricDatum {
	range?: metasearch.DateRange
	event_type: string
	total_scored: bigint
	approved_count: bigint
	rejected_count: bigint
	review_count: bigint
	auto_approved_count: bigint
	profile_id: string
}

export interface AssetTypeMetricSearchResponse {
	next?: SearchRequest
	items: AssetTypeMetricDatum[]
}

export function SearchZero(proto: Partial<SearchRequest> = {}): SearchRequest {
	return {
		brand_id: uuid.NIL,
		range: metasearch.dateranges.everything(),
		group_by: GroupBy.UPLOADER,
		...proto,
	}
}

export function search_approvals(req: SearchRequest, ...options: httpx.option[]): CancellablePromise<SearchResponse> {
	return httpx.get(`${httpx.urlstorage.host()}/brands/${req.brand_id}/bg/metrics/approvals`, req, ...options)
}

export function search_training(req: SearchRequest, ...options: httpx.option[]): CancellablePromise<AssetTypeMetricSearchResponse> {
	return httpx.get(`${httpx.urlstorage.host()}/brands/${req.brand_id}/bg/metrics/training`, req, ...options)
}

export function search_uploads(req: SearchRequest, ...options: httpx.option[]): CancellablePromise<SearchResponse> {
	return httpx.get(`${httpx.urlstorage.host()}/brands/${req.brand_id}/bg/metrics/uploads`, req, ...options)
}

export function search_asset_types(req: SearchRequest, ...options: httpx.option[]): CancellablePromise<AssetTypeMetricSearchResponse> {
	return httpx.get(`${httpx.urlstorage.host()}/brands/${req.brand_id}/bg/metrics/asset-types`, req, ...options)
}

export interface ScoreFailureMetricDatum {
	range?: metasearch.DateRange
	event_type: string
	score_category: string
	failure_count: bigint
	total_scored: bigint
	failure_rate: number
	profile_id: string
}

export interface ScoreFailureMetricSearchResponse {
	next?: SearchRequest
	items: ScoreFailureMetricDatum[]
}

export function search_score_failures(req: SearchRequest, ...options: httpx.option[]): CancellablePromise<ScoreFailureMetricSearchResponse> {
	return httpx.get(`${httpx.urlstorage.host()}/brands/${req.brand_id}/bg/metrics/score-failures`, req, ...options)
}

export interface ModelAccuracyMetricDatum {
	range?: metasearch.DateRange
	event_type: string
	total_reviewed: bigint
	agreement_count: bigint
	false_positive_count: bigint
	false_negative_count: bigint
	accuracy_rate: number
	profile_id: string
}

export interface ModelAccuracyMetricSearchResponse {
	next?: SearchRequest
	items: ModelAccuracyMetricDatum[]
}

export function search_model_accuracy(req: SearchRequest, ...options: httpx.option[]): CancellablePromise<ModelAccuracyMetricSearchResponse> {
	return httpx.get(`${httpx.urlstorage.host()}/brands/${req.brand_id}/bg/metrics/model-accuracy`, req, ...options)
}

export interface FeedbackTrendMetricDatum {
	range?: metasearch.DateRange
	event_type: string
	category: string
	severity: string
	export_count: bigint
	email_count: bigint
	total_count: bigint
	profile_id: string
}

export interface FeedbackTrendMetricSearchResponse {
	next?: SearchRequest
	items: FeedbackTrendMetricDatum[]
}

export function search_feedback_trends(req: SearchRequest, ...options: httpx.option[]): CancellablePromise<FeedbackTrendMetricSearchResponse> {
	return httpx.get(`${httpx.urlstorage.host()}/brands/${req.brand_id}/bg/metrics/feedback-trends`, req, ...options)
}
